module.exports = __webpack_public_path__ + "img/GE.9cd2175e.svg";